import { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { StarRating } from './StarRating';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReviewForm = ({ kuponId, onReviewSubmitted }) => {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!rating) {
      toast.error('Por favor selecciona una kalifikación');
      return;
    }
    
    if (!comment.trim()) {
      toast.error('Por favor escribe un komentario');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post(
        `${API}/reviews`,
        {
          kuponId,
          rating,
          comment: comment.trim()
        },
        {
          headers: { 'X-User-Id': user.id }
        }
      );
      
      toast.success('¡Review publicada exitosamente!');
      setComment('');
      setRating(5);
      
      if (onReviewSubmitted) {
        onReviewSubmitted();
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      toast.error(error.response?.data?.detail || 'Error al publicar review');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <motion.form
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      onSubmit={handleSubmit}
      className="bg-card rounded-2xl p-6 border border-border/50"
      data-testid="review-form"
    >
      <h3 className="font-semibold text-lg mb-4">Deja tu Review</h3>
      
      <div className="space-y-4">
        <div>
          <Label>Kalifikación</Label>
          <div className="mt-2">
            <StarRating
              rating={rating}
              interactive={true}
              onRatingChange={setRating}
              size="lg"
            />
          </div>
        </div>
        
        <div>
          <Label htmlFor="comment">Komentario</Label>
          <Textarea
            id="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Komparte tu experiencia kon este kupon..."
            className="rounded-xl mt-2 min-h-[100px]"
            maxLength={500}
            required
            data-testid="review-comment-input"
          />
          <p className="text-xs text-muted-foreground mt-1">
            {comment.length}/500 karakteres
          </p>
        </div>
        
        <Button
          type="submit"
          disabled={submitting || !comment.trim()}
          className="w-full bg-local-sage hover:bg-local-sage/90 rounded-full"
          data-testid="submit-review-button"
        >
          {submitting ? (
            'Publikando...'
          ) : (
            <>
              <Send className="w-4 h-4 mr-2" />
              Publikar Review
            </>
          )}
        </Button>
      </div>
    </motion.form>
  );
};
